import { useEffect, useState } from "react";
import { getActiveAuthTagList } from "../services/authTagService";

interface IUseFetchActiveAuthTags {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  authTagIds?: number[];
  enabled?: boolean;
}

const useFetchActiveAuthTagsList = ({
  setIsLoading,
  authTagIds,
  enabled = true,
}: IUseFetchActiveAuthTags): [any[], () => Promise<void>] => {
  const [activeAuthTagsData, setActiveAuthTagsData] = useState<any[]>([]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      // Use unified function - pass authTagIds if available, otherwise fetch all
      const result = await getActiveAuthTagList(authTagIds);

      // Ensure result is always an array (matching dummy.json structure)
      setActiveAuthTagsData(Array.isArray(result) ? result : []);
    } catch (err) {
      console.error("Error fetching auth tags:", err);
      setActiveAuthTagsData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!enabled) {
      setActiveAuthTagsData([]);
      return;
    }
    fetchData();
  }, [enabled, authTagIds]); // Add authTagIds to dependency array

  return [activeAuthTagsData, fetchData];
};

export default useFetchActiveAuthTagsList;
